/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Features_Event_TwoInputs */

const en_features_event_two = /** @type {(inputs: Features_Event_TwoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Running technique workshop`)
};

const pl_features_event_two = /** @type {(inputs: Features_Event_TwoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Warsztat techniki biegu`)
};

/**
* | output |
* | --- |
* | "Running technique workshop" |
*
* @param {Features_Event_TwoInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const features_event_two = /** @type {((inputs?: Features_Event_TwoInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_Event_TwoInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_features_event_two(inputs)
	return en_features_event_two(inputs)
});